import styled from 'styled-components';

import {
  Header as HeaderLayoutComponent, Text as TextLayoutComponent, Segment as SegmentLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Text = styled(TextLayoutComponent)``;

export const Header = styled(HeaderLayoutComponent)``;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  margin: 80px auto 0px auto;
  max-width: 1200px;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px ${({ isPadding }) => (isPadding ? '100px' : '')};
  }
`;

export const Instructions = styled.div`
  display: inline-flex;
`;

export const Bold = styled.strong`
  font-weight: 500;
`;
